import RankNine from '@assets/icons/rank-nine.svg'
import { Icon } from './Icon'

export const RankNineIcon = Icon(RankNine)
